// State metadata for per-state SEO landing pages (supervisors + internships)
export const STATE_MAP = {
  texas: {
    name: 'Texas',
    abbr: 'TX',
    cities: ['Houston', 'San Antonio', 'Dallas', 'Austin', 'Fort Worth', 'El Paso'],
    verifiedBoard: 'Texas BHEC',
  },
  california: {
    name: 'California',
    abbr: 'CA',
    cities: ['Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Sacramento', 'Fresno'],
  },
  florida: {
    name: 'Florida',
    abbr: 'FL',
    cities: ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'St. Petersburg', 'Fort Lauderdale'],
  },
  'new-york': {
    name: 'New York',
    abbr: 'NY',
    cities: ['New York City', 'Buffalo', 'Rochester', 'Albany', 'Syracuse', 'Yonkers'],
  },
  michigan: {
    name: 'Michigan',
    abbr: 'MI',
    cities: ['Detroit', 'Grand Rapids', 'Ann Arbor', 'Lansing', 'Flint', 'Kalamazoo'],
  },
  nevada: {
    name: 'Nevada',
    abbr: 'NV',
    cities: ['Las Vegas', 'Reno', 'Henderson', 'North Las Vegas', 'Carson City', 'Sparks'],
  },
};

export const STATE_SLUGS = Object.keys(STATE_MAP);
